import React, { useState } from 'react';
import { AiOutlineArrowLeft } from "react-icons/ai";
interface LayersProps {
    selectedLayers: string[];
    setSelectedCrackScreen: React.Dispatch<React.SetStateAction<string | null>>;
    setSelectedLayers: React.Dispatch<React.SetStateAction<string[]>>;
}

const Layers: React.FC<LayersProps> = ({ setSelectedCrackScreen, selectedLayers, setSelectedLayers }) => {

    const [layers, setLayers] = useState<string[]>(['Overview', 'Power Consumption', 'Temperature', 'Humidity', 'Air Flow', 'Air Percentage', 'White Space']);


    const toggleLayer = (layer: string) => {
        // setSelectedLayers((prev) =>
        //     prev.includes(layer)
        //         ? prev.filter((l) => l !== layer)
        //         : [...prev, layer]
        // );
        setSelectedLayers([layer]);
    };
    return (
        <div className='mb-1'>

            <div className="flex items-center gap-4 flex-wrap">
                <button
                    onClick={() => setSelectedCrackScreen(null)}
                    className="flex items-center gap-1 text-white px-2 py-1  bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer"
                >
                    <AiOutlineArrowLeft size={20} />
                    Back
                </button>

                {layers.map((layer) => {
                    const isChecked = selectedLayers.includes(layer);
                    return (
                        <label
                            key={layer}
                            htmlFor={layer}
                            className="flex items-center gap-2 cursor-pointer select-none"
                        >
                            <input
                                type="checkbox"
                                id={layer}
                                checked={isChecked}
                                onChange={() => toggleLayer(layer)}
                                className={`
                relative appearance-none w-5 h-5 border-2 rounded-md cursor-pointer
                ${isChecked ? "bg-blue/50 border-blue" : "border-gray-400"}
              `}
                            />
                            {/* Custom tick (show only when checked) */}
                            {isChecked && (
                                <span className="absolute w-5 h-5 flex items-center justify-center pointer-events-none">
                                    <svg
                                        className="w-3 h-3 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="3"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                            )}
                            <span className={`text-sm font-medium ${isChecked ? "text-blue" : "text-white"}`}>
                                {layer}
                            </span>
                        </label>
                    );
                })}
            </div>

        </div>
    );
};

export default Layers;